/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';

export const LOCATION_FRAGMENT = gql`
  fragment location on LocationNode {
    address1
    address2
    city
    id
    lat
    lng
    name
    postalCode
    state
    timezone
  }
`;
